import React from "react"
import { Box, useTheme } from "@mui/material"
import { PageCard, PageCardContent } from "components/card"
import { MotionDiv } from "components/motions"
import { TransportationCard } from "extensions/em-transportation/components/TransportationCard"

import { useTransportation } from "extensions/em-transportation/hooks/useTransportation"
import { Link } from "react-router-dom"
import { getIcon } from "utils/icon"
import { AppNavigation } from "containers/AppNavigation"
import { NavigationControl } from "components/kioskHorizontal/navigation"

export const EmTransportationKioskHPage = ({ Layout = Box }) => {
  const { transportationTypes } = useTransportation()
  const theme = useTheme()

  const { styleOverrides: bannerStyleOverrides = {} } =
    theme.components[`AppBanner`] || {}
  const sideBarStyleOverrides =
    theme.components[`AppSidebar`]?.styleOverrides || {}
  const { root: bannerRoot } = bannerStyleOverrides
  const { wrapper, body, footer } = sideBarStyleOverrides

  const styleOverrides =
    theme.components[`EmTransportationPage`]?.styleOverrides || {}
  const { root, pageCardContent, motionDiv, cardWrapper } = styleOverrides

  return (
    <Layout
      aside={
        <PageCard>
          <Box sx={wrapper}>
            <Box sx={bannerRoot}></Box>
            <Box sx={body}>
              <AppNavigation />
            </Box>
            <Box sx={footer}>
              <NavigationControl BackButtonProps={{ hidden: true }} />
            </Box>
          </Box>
        </PageCard>
      }
    >
      <PageCard sx={root}>
        <MotionDiv
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.15 }}
          sx={motionDiv}
        >
          <PageCardContent sx={pageCardContent}>
            <Box sx={cardWrapper}>
              {transportationTypes.length > 0 &&
                transportationTypes.map(
                  ({ id, title, link, image, ...rest }) => (
                    <TransportationCard
                      component={Link}
                      key={id}
                      to={link}
                      title={title}
                      image={image}
                      icon={getIcon(rest)}
                    />
                  )
                )}
            </Box>
          </PageCardContent>
        </MotionDiv>
      </PageCard>
    </Layout>
  )
}
